<template>
  <div>
    <el-dialog title="赠品信息" :visible.sync="dialogVisible" v-if="dialogVisible" customClass="way zengpin" :before-close="handleClose">
      <p style="color:#ff0000" v-if="dialogVisible">赠品比率为1~100，最终数量为送货数量*赠品比率</p><br>
      <table cellspacing="0" cellpadding="0" class="Projectdetails" v-if="dialogVisible">
        <tbody>
          <tr>
            <td style="width:80px">赠品名称</td>
            <td style="min-width:110px">
              <div v-if="!tibaoif&&crm=='1'" style="position: relative;">
                <el-input v-model="wuliaoData.cinvname" placeholder="请选择赠品"></el-input>
                <el-button size="mini" type="success" class="fsyzm" @click="GetGiveawayInvbillList()">选择赠品</el-button>
                <!-- <el-select v-model="wuliaoData.csrminvcode" filterable placeholder="请选择" @change="wuliao" style="width:auto">
                    <el-option v-for="(item,i) in InvbillList" :key="i" :label="item.cinvname" :value="item.csrminvcode">
                    </el-option>
                  </el-select> -->
              </div>
              <span v-if="crm=='0'" @click="crmwul()">{{wuliaoData.cinvname}}</span>
            </td>

            <td style="width:70px">计量单位</td>
            <td style="width:110px">
              <span>{{wuliaoData.cmainunit}}</span>
            </td>
          </tr>
          <tr>
            <td style="width:100px">赠品比例（%）</td>
            <td style="width:140px">
              <el-input size="small" v-model="wuliaoData.izpbl_price" :disabled="tibaoif" oninput="value=value.replace(/[^\([0-9]|[0-9]\\d|100]/g,'')"></el-input>

            </td>

            <td style="width:100px">赠品数量</td>
            <td style="width:140px" v-if="zengpinrow.ipricenum && wuliaoData.izpbl_price!=0">
              {{zengpinrow.ipricenum*wuliaoData.izpbl_price/100}}

            </td>
            <td style="width:140px" v-else>
              {{wuliaoData. izsnumber}}
            </td>
          </tr>
        </tbody>
      </table>
      <span slot="footer" class="dialog-footer" v-if="dialogVisible">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="SaveInvbill()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="赠品" :visible.sync="dialogFormVisible" customClass="way sadform1" :append-to-body="true">
      <div style="width:100%" class="pull-left">
        <el-form :inline="true" :model="zengpin" class="demo-form-inline">
          <el-form-item label="赠品名称">
            <el-input v-model="zengpin.cinvname" placeholder="赠品名称"></el-input>
          </el-form-item>

          <el-form-item>
            <Debounce :time='300' :isDebounce="1">
              <el-button type="primary" @click.native="GetGiveawayInvbillList()" size="medium">查询</el-button>
            </Debounce>
          </el-form-item>
        </el-form>

        <el-table :data="InvbillList" border style="width: 100%" max-height="320" @current-change="clickChange" tooltip-effect :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
          <el-table-column label="选择" width="55">
            <template slot-scope="scope">
              <el-radio v-model="tablerow" :label="scope.row">
                <i>
                </i>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="csrminvcode" label="编号" width="140"></el-table-column>
          <el-table-column prop="cinvname" label="赠品名称"></el-table-column>
          <el-table-column prop="cmainunit" label="计量单位" width="80"></el-table-column>
        </el-table>

        <div class="pull-right" style="padding:20px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="wuliaofenye.pageSize" layout="total, sizes, prev, pager, next" :total="wuliaofenye.totalCount">
          </el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad()">取 消</el-button>
        <el-button type="success" @click="banksubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: { type: Boolean },
    zengpinrow: { type: Object },
    wuliaoData: { type: Object },
    tibaoif: { type: Boolean },
    crm: { type: String },
  },
  data() {
    return {
      wuliaofenye: {
        pageSize: 10,
        pageIndex: 1,
        totalCount: 0,
      },
      dialogFormVisible: false,
      zengpin: {
        cinvname: "",
      },
      zengpinlist: [],
      InvbillList: [],
      tablerow: {},
    };
  },
  created() {},
  methods: {
    // 单选
    clickChange(item) {
      this.tablerow = item;
      console.log(this.tablerow);
    },
    // 分页
    handleSizeChange(val) {
      this.wuliaofenye.pageSize = val;
      this.GetGiveawayInvbillList();
    },
    // 分页
    handleCurrentChange(val) {
      this.wuliaofenye.pageIndex = val;
      this.GetGiveawayInvbillList();
    },
    crmwul() {
      this.crm = "1";
    },

    // 获取赠品信息
    GetGiveawayInvbillList() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetGiveawayInvbillList",
        data: {
          KeyValue: this.zengpinrow.op_inquiry_price_autoid,
          pageSize: this.wuliaofenye.pageSize,
          pageIndex: this.wuliaofenye.pageIndex,
          cinvname: this.zengpin.cinvname,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.InvbillList = res.data.Data.rows;
          this.wuliaofenye.totalCount = res.data.Data.totalCount;
          // this.InvbillList.push({
          //   cinvcode: "",
          //   cinvmodel: "",
          //   cinvname: this.zengpinrow.cinvname_price,
          //   cmainunit: this.zengpinrow.cunit_price,
          //   csrminvcode: this.zengpinrow.csrminvcode_price,
          // });
          this.dialogFormVisible = true;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    closesad() {
      this.dialogFormVisible = false;
    },
    // 赠品
    handleClose() {
      this.$emit("dialog", false);
    },
    //确认
    banksubmit() {
      console.log(this.tablerow, this.wuliaoData);
      this.wuliaoData.cinvname = this.tablerow.cinvname;
      this.wuliaoData.csrminvcode = this.tablerow.csrminvcode;
      this.dialogFormVisible = false;
      // if (this.tablerow.cbankname) {
      //   this.form.cbankname = this.tablerow.cbankname;
      //   this.form.cbankcode = this.tablerow.cbankcode;
      //   this.form.cbankcontray = this.tablerow.cbankcontray;
      //   this.dialogFormVisible = false;
      // } else {
      //   this.$message.error("请选择银行信息！");
      // }
    },
    // 保存
    SaveInvbill() {
      if (this.wuliaoData.csrminvcode != "") {
        if (
          this.wuliaoData.izpbl_price != "" &&
          this.wuliaoData.izpbl_price < 101
        ) {
          this.wuliaoData.izsnumber =
            (this.zengpinrow.ipricenum * this.wuliaoData.izpbl_price) / 100;
          console.log(this.wuliaoData, "123456");
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/SaveGiveawayInvbill",
            data: {
              autoid: this.zengpinrow.op_inquiry_price_autoid,
              JsonInfo: JSON.stringify(this.wuliaoData),
            },
          }).then((res) => {
            console.log(res);
            if (res.data.Success) {
              this.$message.success("添加成功！！");
              // this.tableData[this.scopeindex].czsnumber = "有";
              this.$emit("czsnumber", "有");
              this.handleClose();
            } else {
              this.$message.error(res.data.Message);
            }
          });
        } else {
          this.$message.error("赠品比率为1~100,请重新输入赠送比例！");
        }
      } else {
        this.$message.error("请选择物料！");
      }
    },
    wuliao(e) {
      this.crm = "0";
      if (this.zengpinrow) {
        this.InvbillList.forEach((row) => {
          if (row.csrminvcode == e) {
            if (
              this.zengpinrow.ipricenum != 0 &&
              this.zengpinrow.ipricenum &&
              this.wuliaoData.izpbl_price != ""
            ) {
              this.wuliaoData = {
                csrminvcode: row.csrminvcode,
                cinvname: row.cinvname,
                izpbl_price: this.wuliaoData.izpbl_price,
                cmainunit: row.cmainunit,
                izsnumber:
                  (this.zengpinrow.ipricenum * this.wuliaoData.izpbl_price) /
                  100,
              };
            } else {
              this.wuliaoData = {
                csrminvcode: row.csrminvcode,
                cinvname: row.cinvname,
                izpbl_price: this.wuliaoData.izpbl_price,
                cmainunit: row.cmainunit,
                izsnumber: 0,
              };
            }
          }
        });
      }
    },
  },
  beforeDestroy() {
    this.informdata = {};
  },
};
</script>
<style scoped>
.fsyzm {
  position: absolute;
  right: 0;
  top: 5px;
}
</style>